import { SVGProps } from 'react';

interface Props extends SVGProps<SVGSVGElement> {
}

export const SvgClose = (props: Props) => (
  <svg {...props} width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M18.764 5.71388L18.7861 5.73596C19.0713 6.02114 19.0713 6.48351 18.7861 6.76869L13.0548 12.5L18.7861 18.2313C19.0713 18.5165 19.0713 18.9789 18.7861 19.264L18.764 19.2861C18.4789 19.5713 18.0165 19.5713 17.7313 19.2861L12 13.5548L6.26869 19.2861C5.98351 19.5713 5.52114 19.5713 5.23596 19.2861L5.21388 19.264C4.92871 18.9789 4.92871 18.5165 5.21388 18.2313L10.9452 12.5L5.21388 6.76869C4.92871 6.48351 4.92871 6.02114 5.21388 5.73596L5.23596 5.71388C5.52114 5.42871 5.98351 5.42871 6.26869 5.71388L12 11.4452L17.7313 5.71388C18.0165 5.42871 18.4789 5.42871 18.764 5.71388Z"
      fill="#C0BEBE" />
  </svg>
);